import styled from "styled-components";

export const Divider = styled.div`
  background-color: #d2d2d2;
  width: calc(100% + 90px);
  margin-left: -45px;
  height: 1px;
`;